import React from "react";
import { FaEdit } from "react-icons/fa";

const poleTypeDict = {
  METAL: "Metal",
  ROUND_CONCRETE: "Concreto redondo",
  DOUBLE_T_CONCRETE: "Concreto duplo T",
};

const ObjectDetailsGroundInfo = ({
  pointDetailOffcanvas,
  toggleEditTreeModal,
}) => {
  return (
    <tbody>
      <tr>
        <th>Latitude:</th>
        <td>{pointDetailOffcanvas.point.latitude}</td>
      </tr>

      <tr>
        <th>Longitude:</th>
        <td>{pointDetailOffcanvas.point.longitude}</td>
      </tr>

      {pointDetailOffcanvas.point.poleType && (
        <tr>
          <th>Tipo de poste:</th>
          <td>{poleTypeDict[pointDetailOffcanvas.point.poleType]}</td>
        </tr>
      )}

      {pointDetailOffcanvas.point.streetName != null && (
        <tr>
          <th>Nome da rua:</th>
          <td>{pointDetailOffcanvas.point.streetName}</td>
        </tr>
      )}

      {pointDetailOffcanvas.point.height != null && (
        <tr>
          <th>Altura:</th>
          <td>{pointDetailOffcanvas.point.height.toFixed(2)} m</td>

          {pointDetailOffcanvas.type === "trees" && (
            <td style={{ cursor: "pointer" }} onClick={toggleEditTreeModal}>
              <FaEdit />
            </td>
          )}
        </tr>
      )}

      {pointDetailOffcanvas.point.inclination != null && (
        <tr>
          <th>Inclinação:</th>
          <td>{pointDetailOffcanvas.point.inclination.toFixed(2)}°</td>
        </tr>
      )}

      {pointDetailOffcanvas.point.streetWidth != null && (
        <tr>
          <th>Largura da rua:</th>
          <td>{pointDetailOffcanvas.point.streetWidth.toFixed(2)} m</td>
        </tr>
      )}

      {pointDetailOffcanvas.point.setBack != null && (
        <tr>
          <th>Recuo da rua:</th>
          <td>{pointDetailOffcanvas.point.setBack.toFixed(2)} m</td>
        </tr>
      )}

      {pointDetailOffcanvas.point.distanceToTheNextPole != null && (
        <tr>
          <th>Distância para o próximo poste:</th>
          <td>
            {pointDetailOffcanvas.point.distanceToTheNextPole.toFixed(2)} m
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default ObjectDetailsGroundInfo;
